var map = {
	"./10_nuts.png": 2470,
	"./1drink_12beer.png": 2471,
	"./1serving_8ounces.png": 2472,
	"./1serving_8ounces2.png": 2473,
	"./1serving_8ounces3.png": 2474,
	"./1serving_8ounces4.png": 2475,
	"./1serving_8ounces5.png": 2476,
	"./8ounces_1glass.png": 2477,
	"./can_1.png": 2478,
	"./can_2.png": 2479,
	"./can_3.png": 2480,
	"./cup.png": 2481,
	"./dried_serving_1/4cup.png": 2482,
	"./dried_serving_1:4cup.png": 2483,
	"./fresh_serving_1cup.png": 2484,
	"./glass_1.png": 2485,
	"./glass_2.png": 2486,
	"./golfball.png": 2487,
	"./halfthumb.png": 2488,
	"./hand_1.png": 2489,
	"./hand_2.png": 2490,
	"./hand_3.png": 2491,
	"./hand_4.png": 2492,
	"./hand_5.png": 2493,
	"./how.png": 892,
	"./serving_1/2cup.png": 2494,
	"./serving_1:2cup.png": 2495,
	"./serving_1tbsp.png": 2496,
	"./serving_3/4ounces.png": 2497,
	"./serving_3:4ounces.png": 2498,
	"./thumbx2.png": 2499,
	"./usda.png": 2500,
	"./vegetables_1cup.png": 2501,
	"./what.png": 890,
	"./wholethumb.png": 2502,
	"./why.png": 891
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2469;